import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {MANAGE_PERMISSIONS, MANAGE_PERMISSIONS_API_URL, GET_ALL_MANAGE_PERMISSIONS_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  ManagePermissionsErrors       : {},
  permission: permission?.manage_permissions ?? [],
  ManagePermissionsShowMessage  : null,
  ManagePermissionsResult       : [],
  ManagePermissionsButtonSpinner : false,
  ManagePermissionsTableLoading : true,
  ManagePermissionsAddDrawer    : false,
  ManagePermissionsEditData     : [],
  ManagePermissionsButtonAndModelLabel  : setLocale('managepermissions.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewManagePermissionsData: [],
    ViewManagePermissionsLoader: true,
    DrawerStatus: 0,
};

export const createManagePermissions = createAsyncThunk(
    "createManagePermissions",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, MANAGE_PERMISSIONS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManagePermissions = createAsyncThunk(
    "getManagePermissions",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_MANAGE_PERMISSIONS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewManagePermissions = createAsyncThunk(
  "viewManagePermissions",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, MANAGE_PERMISSIONS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteManagePermissions = createAsyncThunk(
  "deleteManagePermissions",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, MANAGE_PERMISSIONS_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageManagePermissionsSlice = createSlice({
  name: MANAGE_PERMISSIONS,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.ManagePermissionsErrors = {};
    },
    ManagePermissionsAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.ManagePermissionsButtonSpinner = false;
      }
      state.ManagePermissionsAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManagePermissionsEditData    = [];
      state.ManagePermissionsButtonAndModelLabel = setLocale('managepermissions.add');
    },
    ManagePermissionsEditWithDrawerStatus: (state, action) => {
      state.ManagePermissionsAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManagePermissionsEditData = action.payload.data;
      state.ManagePermissionsButtonAndModelLabel = setLocale('managepermissions.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createManagePermissions.pending, (state, action) => {
        state.DrawerStatus = 0
        state.ManagePermissionsButtonSpinner = true;
      }).addCase(createManagePermissions.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.ManagePermissionsButtonSpinner = false;
        state.ManagePermissionsErrors = {}
      }).addCase(createManagePermissions.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.ManagePermissionsShowMessage = true;
        state.ManagePermissionsButtonSpinner = false;
        state.ManagePermissionsErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getManagePermissions.pending, (state, action) => {
        state.ManagePermissionsButtonSpinner = true;
        state.ManagePermissionsTableLoading = true;
      }).addCase(getManagePermissions.fulfilled, (state, action) => {
        state.ManagePermissionsButtonSpinner = false;
        state.ManagePermissionsTableLoading = false;
        state.ManagePermissionsResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getManagePermissions.rejected, (state, action) => {
        state.ManagePermissionsShowMessage = true; // Set the showMessage flag to display the errors
        state.ManagePermissionsButtonSpinner = false;
        state.ManagePermissionsTableLoading = false;
        state.ManagePermissionsErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewManagePermissions.pending, (state, action) => {
        state.ViewManagePermissionsLoader = true;
        state.ViewManagePermissionsData = [];
      }).addCase(viewManagePermissions.fulfilled, (state, action) => {
        state.ViewManagePermissionsLoader = false;
        state.ViewManagePermissionsData = action.payload;
      }).addCase(viewManagePermissions.rejected, (state, action) => {
        state.ViewManagePermissionsLoader = false;
        state.ViewManagePermissionsData = [];
      })
      .addCase(deleteManagePermissions.pending, (state, action) => {
        state.ManagePermissionsTableLoading = true;
      }).addCase(deleteManagePermissions.fulfilled, (state, action) => {
        state.ManagePermissionsTableLoading = false;
      }).addCase(deleteManagePermissions.rejected, (state, action) => {
        state.ManagePermissionsTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, ManagePermissionsAddDrawerStatus, ManagePermissionsEditWithDrawerStatus, updateSortFilters } = manageManagePermissionsSlice.actions;

export default manageManagePermissionsSlice.reducer;